// Copyright 2018 Sorama B.V.

import { Disposable } from "aurelia-framework";
import { GenericMeasurement } from "datatypes/SoramaWebApi";

export abstract class IMeasurementProcessorResolver {
    /**
     * Determines whether the provided measurement can be processed
     * @param measurements Measurements to process
     */
    abstract canProcess(
        measurements: GenericMeasurement[],
        interfaceKey?: unknown
    ): Promise<{ measurement: GenericMeasurement; available: boolean }[]>;

    /**
     * Resolve a processor of a certain type for a given measurement
     * @param interfaceKey interface to resolve
     * @param measurement Measurement to process
     */
    abstract resolveProcessor<TProcessor>(interfaceKey: unknown, measurement: GenericMeasurement): Promise<TProcessor>;

    /**
     * Purges the cached status for the provided processor interface and measurement combination
     * @param interfaceKey Processor interface to purge
     * @param measurement Measurement to purge
     */
    abstract purgeProcessorStatus(measurementId: string): Promise<void>;

    /**
     * Register a callback to be called when the status has been updated
     * @param statusChangedCallback
     */
    abstract registerProcessorStatusListener(statusChangedCallback: (measurementId: string) => void): Disposable;
}
